import PrimaryRoomView from './PrimaryRoomView';

export default class UserView {
    static ROLE_USER = 'ROLE_USER';
    static ROLE_ANALYST = 'ROLE_ANALYST';
    static ROLE_MANAGER = 'ROLE_MANAGER';
    static ROLE_ADMIN = 'ROLE_ADMIN';
    static ROLE_SUPERADMIN = 'ROLE_SUPERADMIN';

    constructor(json) {
        this.id = json.id;
        this.email = json.email;
        this.firstName = json.firstName;
        this.lastName = json.lastName;
        this.accountType = json.accountType;
        this.roles = json.roles;
        this.anonymized = json.anonymized;
        this.legacyIcal = json.legacyIcal;
        this.calendarNotification = json.calendarNotification;
        this.clearBookedDatesAfterBooking = json.clearBookedDatesAfterBooking;
        this.primaryRoom = null;
        if (json.primaryRoom) {
            this.primaryRoom = new PrimaryRoomView(json.primaryRoom);
        }
        this.timezone = json.timezone;
        this.gravatar = json.gravatar;
        this.avatarName = json.avatarName ?? '';
        this.profileImage = json.profileImage;
        this.licenseActive = json.licenseActive;
        this.initials = json.initials;
        this.komboAvatarUrl = json.komboAvatarUrl;
        this.isKomboUser = json.isKomboUser;
        this.calendarRemovalSync = json.calendarRemovalSync;
        // locations the user might be assigned to for restrciting managers/analysts
        this.assignedLocations = json.assignedLocations || [];
        // live-view settings for desk.ly Connect
        this.liveViewEnabled = json.liveViewEnabled;
        this.liveViewEditable = json.liveViewEditable;
        this.liveViewVisibility = json.liveViewVisibility;
        this.defaultCostCenter = json.defaultCostCenter ?? null;
        this.isVisitorManager = json.isVisitorManager ?? false;
        this.isRoomManager = json.isRoomManager ?? false;
    }
}
